import React from 'react'
import { Mail } from '@olxbr/ds-icons'
import styled, { css } from 'styled-components'
import { Autos360Logo } from '../../atoms/Autos360Logo'

const baseLogoStyles = css`
  width: 126px;
  margin: 0 auto;
  margin-bottom: var(--spacing-1-5);
`

const SizedAutos360Logo = styled(Autos360Logo)`
  ${baseLogoStyles}
`

export const EMAIL_LOGIN_THEMES = {
  DEFAULT: {
    LOGO: null,
    BRAND: { NAME: 'OLX', ARTICLE: 'a' },
    BUTTONS: [
      {
        TEXT: 'Acessar',
        VARIANT: 'primary',
        ACTION: 'login',
      },
    ],
    CONTAINER: {
      TYPE: 'outlined',
    },
  },
  AUTOS360: {
    LOGO: SizedAutos360Logo,
    BRAND: {
      NAME: 'Autos 360',
      ARTICLE: 'e',
      IMAGE:
        'https://static.olx.com.br/static/olxbr/accounts-web-components/assets/logos/autos360-logo-purple.svg',
    },
    BUTTONS: [
      {
        TEXT: 'Entrar',
        VARIANT: 'primary',
        COLOR: 'purple',
        ACTION: 'login',
      },
      {
        TEXT: 'Logar com Autos 360',
        VARIANT: 'secondary',
        COLOR: 'purple',
        ICON: Mail,
        ACTION: 'redirect',
        HREF: 'https://autos360.olx.com.br/acesso',
        TRACKING: {
          OBJECT_DETAIL: 'redirect_autos360_legacy',
        },
      },
    ],
    CONTAINER: {
      TYPE: 'elevated',
    },
  },
}
